import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import ListServiceChargeEdit from "./ListServiceChargeEdit";
import nodeinstance from "../../../../nodeInstance";

export default function ServiceChargeEdit() {
  const [serviceData, SetDropDownList] = useState([{}]);

  const dispatch = useDispatch();

  const titleBorder = [
    { label: "Service Charge Edit", link: "/dashboard/ServiceChargeEdit" },
  ];

  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const token = localStorage.getItem("nodeToken");

  const getData = async (keyword) => {
    console.log(keyword.length);
    try {
      if (keyword.length >= 3) {
        const result = await nodeinstance.get(
          `/service-charge-edit?keyword=${keyword}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = result?.data;
        console.log(data);
        SetDropDownList(data);
      } else {
        SetDropDownList([{}]);
      }
    } catch (error) {
      SetDropDownList([]);
      dispatch(setAppError({ msg: `${error?.message}` }));
    }
  };

  return (
    <>
      <div className={`ml-5 mr-5`}>
        <ListServiceChargeEdit
          list={serviceData}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE NAME",
            "CLIENT",
            "QUOTATION TYPE",
            "Contract Start Date",
            "Contract End Date",
            "Contract Tenure",
            "ARRIVAL DATE",
            "BORDER NUMBER",
            "VISA PROVIDER",
            "IQAMA NUMBER",
            "IQAMA EXPIRY",
            "ACTUAL PROFESSION",
            "IQAMA PROFESSION",
            "PROFESSION LEVEL",
            "SERVICE CHARGE",
            "New SERVICE CHARGE",
            "UPDATED DATE",
            "ACTION",
          ]}
          token={token}
          callBack={getData}
        />
      </div>
    </>
  );
}
